<template>
  <div class="current-wrapper">
   <!--<controls-column :grayscale="grayscale" :toggleScale="toggleScale">
    </controls-column> -->
    <graphic-column
      :quarters="state.quarters"
      :changeHandler="updateQuarter"
      :riskData="riskData"
      :currentA="currentA"
      :currentB="currentB"
      :categories="state.categories"
      :toggleScale="toggleScale"
      :grayscale="grayscale">
    </graphic-column>
  </div>
</template>

<script>
import ControlsColumn from './ControlsColumn';
import GraphicColumn from './GraphicColumn';
import beforeRouteLeave from '../../helpers/navHelpers';

export default {
  name: 'comparison',
  props: ['riskData', 'state', 'grayscale', 'toggleScale', 'setLoading'],
  components: {
    'controls-column': ControlsColumn,
    'graphic-column': GraphicColumn,
  },
  methods: {
    updateQuarter(aOrb, quarterIndex) {
      const newQuarter = this.state.quarters[quarterIndex];
      if (aOrb === 'A') this.state.currentA = newQuarter;
      if (aOrb === 'B') this.state.currentB = newQuarter;
    },
  },
  computed: {
    currentA() {
      return this.state.currentA;
    },
    currentB() {
      return this.state.currentB;
    },
  },
  beforeRouteLeave,
  beforeMount() {
    if (this.$route.name === 'categories') {
      window.scrollTo(0, 818);
    }
  },
};
</script>

<style land="less">
  .current-wrapper {
    display: flex;
    width: 100%;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// Comparison.vue?c53b467a